import { render } from "./harvesterhci.io.volume.vue?vue&type=template&id=2d401ca2"
import script from "./harvesterhci.io.volume.vue?vue&type=script&lang=js"
export * from "./harvesterhci.io.volume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__